import { Button, Card, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";

const RequestItem = (props) => {
  const [isLoading, loading] = useState(false);

  const Column = ({ title, value }) => {
    return (
      <Stack m={3}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle2">{value}</Typography>
      </Stack>
    );
  };

  const _approveHandler = () => {
    if (isLoading) return;
    loading(true);
    setTimeout(() => {
      loading(false);
    }, 3000);
  };
  return (
    <Box m={2}>
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Column title="Organisation" value="Test Organisation" />
          </Grid>
          <Grid item xs={2}>
            <Column title="Requested By" value="Jaseem" />
          </Grid>
          <Grid item xs={2}>
            <Column title="Requested At" value="Jaseem" />
          </Grid>
          <Grid item xs={2}>
            <Column title="Amount" value="Jaseem" />
          </Grid>
          <Grid item xs={2}>
            <Column title="Ticket Info" value="Jaseem" />
          </Grid>
          <Grid item xs={2}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              {isLoading ? (
                <CircularProgress size={20} />
              ) : (
                <Button variant="text" onClick={_approveHandler}>
                  Approve
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default RequestItem;
